import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Title = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2.49997C2.72386 2.49997 2.5 2.72383 2.5 2.99997C2.5 3.27611 2.72386 3.49997 3 3.49997H7.5V13C7.5 13.2761 7.72386 13.5 8 13.5C8.27614 13.5 8.5 13.2761 8.5 13V3.49997H13C13.2761 3.49997 13.5 3.27611 13.5 2.99997C13.5 2.72383 13.2761 2.49997 13 2.49997H8H3Z"
      />
    </svg>
  )
})

export default Title
